import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UtilsService } from 'src/app/shared/utils.service';
import {AuthService} from "../../auth/auth.service";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {DataService} from "../../shared/data.service";

@Component({
    selector: 'app-plans-and-pricing',
    templateUrl: './plans-and-pricing.component.html',
    styleUrls: ['./plans-and-pricing.component.scss'],
    standalone: false
})
export class PlansAndPricingComponent implements OnInit {
  promotionCodeCount: number;
  isItManufacturer=0;
  constructor(private utils: UtilsService, private router: Router, private auth: AuthService, private dataService:DataService) {
  }

  ngOnInit(): void {
    this.utils.setTitle('Plans and Pricing');
    this.utils.screenTitle.emit({firstTitle: 'Plans and pricing', firstRoute: '/pricing-and-plans'});
    this.dataService.get('user/RetrieveUser/' + this.auth.getUserData().id).then((data) => {
      if (data.statusCode === 200) {
        this.promotionCodeCount = data.data.promotionCodeCount;
        if(data.data.type == 3){
          this.isItManufacturer = 1;
        }
      }
    });
  }

  goToBilling(count: any, planName: any, subscriptionsNumber: any, subscriptionsPrice: any, totalPrice: any, stars: any) {
    this.router.navigate(['/plan-billing/' + count ], { queryParams: {planName, subscriptionsNumber, subscriptionsPrice, totalPrice, stars} });
  }

}
